import React, { useCallback, useContext, useMemo } from 'react';
import { Button } from '@fluentui/react-components';
import { MessageBar, MessageBarBody, MessageBarTitle, MessageBarActions } from '@fluentui/react-message-bar';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const MemberTokenWarning = () => {
  const i18n = useContext(I18nContext);
  const { scope } = useContext(ScopeContext);

  const navigateToReAuthFlow = useCallback(() => {
    scope.append({ isReAuth: true });
    scope.remove(['campaignId', 'adGroupId', 'adId']);
    scope.save('/campaign/vnext/createcampaign/linkedin');
  }, [scope]);

  const memberTokenWarning = useMemo(
    () => (
      <MessageBar intent="warning">
        <MessageBarBody>
          <MessageBarTitle>{_TL_('Your LinkedIn authentication has been revoked.')}</MessageBarTitle>
          {_TL_('Please re-authenticate to continue using LinkedIn features.')}
        </MessageBarBody>
        <MessageBarActions>
          <Button appearance="primary" size="small" onClick={navigateToReAuthFlow} aria-label={i18n.getString(_TL_('Re-authenticate'))}>
            {_TL_('Click here')}
          </Button>
        </MessageBarActions>
      </MessageBar>
    ),
    [i18n, navigateToReAuthFlow]
  );

  return memberTokenWarning;
};

